<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    custom-class="service-dialog"
    width="90%"
    @close="handleClose"
  >
    <div class="dialog-header">
      <div class="dialog-top">
        <img :src="require('@/assets/logo-active.png')" alt="亚科Logo" class="dialog-logo">
        <div class="dialog-title">
          {{ getText('croCdmoDialog.hotline', '免费服务热线：') }}<span> {{currentLanguage !=='zh'?'+86-15062454963':'13451648594'}} </span>
        </div>
      </div>
      <div class="dialog-bottom">
        {{ getText('croCdmoDialog.description', '请留下您的需求信息，我们将在1个工作日内与您联系') }}
      </div>
    </div>

    <el-form
      ref="serviceForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      class="service-form"
      label-width="80px"
    >
      <el-form-item :label="getText('croCdmoDialog.form.name', '姓名')" prop="name">
        <el-input 
          v-model="formData.name"
          :placeholder="getText('croCdmoDialog.form.namePlaceholder', '请输入您的姓名')"
        />
      </el-form-item>

      <el-form-item :label="getText('croCdmoDialog.form.contact', '联系方式')" prop="contact">
        <el-input
            v-model="formData.contact"
            :placeholder="getText('croCdmoDialog.form.contactPlaceholder', '请输入您的电话/手机号/邮箱')"
        />
      </el-form-item>

      <el-form-item :label="getText('croCdmoDialog.form.company', '公司名称')" prop="company">
        <el-input
            v-model="formData.company"
            :placeholder="getText('croCdmoDialog.form.companyPlaceholder', '请输入您的公司名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('croCdmoDialog.form.product', '产品名称')" prop="product">
        <el-input
            v-model="formData.product"
            :placeholder="getText('croCdmoDialog.form.productPlaceholder', '请输入产品名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('croCdmoDialog.form.cas', 'CAS号')" prop="cas">
        <el-input
            v-model="formData.cas"
            :placeholder="getText('croCdmoDialog.form.casPlaceholder', '请输入CAS号')"
        />
      </el-form-item>

      <el-form-item :label="getText('croCdmoDialog.form.requirement', '采购需求')" prop="requirement">
        <el-input
            v-model="formData.requirement"
            type="textarea"
            :rows="4"
            :placeholder="getText('croCdmoDialog.form.requirementPlaceholder', '请输入您的采购需求')"
        />
      </el-form-item>

      <!-- 添加文件上传 -->
      <el-form-item :label="getText('croCdmoDialog.form.attachment', '附件')">
        <div class="upload-area" @click="triggerUpload" v-if="!fileInfo">
          <i class="el-icon-upload"></i>
          <div class="upload-text">
            <p>{{ getText('croCdmoDialog.upload.clickToUpload', '点击上传附件') }}</p>
            <p class="upload-tip">{{ getText('croCdmoDialog.upload.fileFormat', '文件格式：jpg、pdf、doc，文件大小不超过5M') }}</p>
          </div>
          <input 
            type="file" 
            ref="fileInput" 
            @change="handleFileChange" 
            accept=".jpg,.pdf,.doc,.docx"
            style="display: none"
          >
        </div>
        <div class="file-info" v-else>
          <div class="file-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="file-name">{{ fileInfo.name }}</div>
          <div class="file-actions">
            <i class="el-icon-delete" @click="removeFile"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item class="form-footer">
        <el-button type="primary" @click="handleSubmit">{{ getText('croCdmoDialog.form.submit', '提交') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { submitProductForm } from '@/api'
import { uploadToOss } from '@/api/oss'
import {mapState} from "vuex";

export default {
  name: 'CroOrCdmoDialog',
  
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      visible: false,
      fileInfo: null,
      formData: {
        name: '',
        contact: '',
        company: '',
        product: '',
        cas: '',
        requirement: '',
        belongs: 1,
        url: '', // 附件URL
        type: 2  // 类型为2表示CRO/CDMO
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        cas: [
          { required: true, message: '请输入CAS号', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    rules() {
      return {
        name: [
          { required: true, message: this.getText('croCdmoDialog.validation.nameRequired', '请输入姓名'), trigger: 'blur' }
        ],
        contact: [
          { required: true, message: this.getText('croCdmoDialog.validation.contactRequired', '请输入联系方式'), trigger: 'blur' }
        ],
        cas: [
          { required: true, message: this.getText('croCdmoDialog.validation.casRequired', '请输入CAS号'), trigger: 'blur' }
        ]
      }
    },
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh'
    })
  },

  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    },
    item: {
      handler(newVal) {
        if (newVal && newVal.casNo) {
          this.formData.cas = newVal.casNo
          if (newVal.name) {
            this.formData.product = newVal.name
          }
          this.formData.belongs = newVal.belongs
        }
      },
      immediate: true
    }
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },
    show() {
      this.visible = true
    },

    handleClose() {
      this.visible = false
      this.fileInfo = null
      this.formData.url = ''
      this.$refs.serviceForm.resetFields()
    },

    triggerUpload() {
      this.$refs.fileInput.click()
    },

    async handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        // 检查文件大小（5MB）
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error(this.getText('croCdmoDialog.upload.fileSizeError' , '文件大小不能超过5M'))
          return
        }
        
        // 检查文件类型
        const allowedTypes = [
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ]
        if (!allowedTypes.includes(file.type)) {
          this.$message.error(this.getText('croCdmoDialog.upload.fileTypeError', '请上传jpg、pdf或doc格式的文件'))
          return
        }

        try {
          // 显示上传加载状态
          this.$loading.show()

          // 上传文件到OSS
          const fileUrl = await uploadToOss(file, 'cro-cdmo')
          this.formData.url = fileUrl
          this.fileInfo = file

          this.$loading.hide()
          this.$message.success(this.getText('croCdmoDialog.upload.uploadSuccess', '文件上传成功'))
        } catch (error) {
          console.error('文件上传失败:', error)
          this.$message.error(this.getText('croCdmoDialog.upload.uploadFailed', '文件上传失败，请重试'))
        }
      }
      // 清空input的value，允许重复选择同一文件
      event.target.value = ''
    },

    removeFile() {
      this.fileInfo = null
      this.formData.url = ''
    },

    async handleSubmit() {
      try {
        const valid = await this.$refs.serviceForm.validate()
          .catch(error => {
            console.error('表单验证失败:', error)
            return false
          })

        if (!valid) return

        this.$loading.show()

        try {
          const response = await submitProductForm(this.formData)
          
          if (response.success) {
            this.$message.success(this.getText('croCdmoDialog.messages.submitSuccess', '提交成功'))
            this.handleClose()
          } else {
            this.$message.error(response.msg || this.getText('croCdmoDialog.messages.submitFailed', '提交失败'))
          }
        } finally {
          this.$loading.hide()
        }
      } catch (error) {
        console.error('提交表单失败:', error)
        this.$message.error(this.getText('croCdmoDialog.messages.submitFailedRetry', '提交失败，请稍后重试'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.service-dialog {
  :deep(.el-dialog) {
    margin: 20px auto !important;
    width: 90% !important;
    max-width: 400px;
    border-radius: 12px;
  }

  :deep(.el-dialog__header) {
    display: none;
  }

  :deep(.el-dialog__body) {
    padding: 0 !important;
  }

  .dialog-header {
    padding: 10px 10px 0;
    background: #f8f9fa;
    border-radius: 6px 6px 0 0;

    .dialog-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;

      .dialog-logo {
        width: 80px;
        height: auto;
        margin-bottom: 15px;
      }

      .dialog-title {
        font-size: 14px;
        color: #333;
        text-align: center;

        line-height: 1.4;
        position: relative;
        margin: 0;

        span {
          color: var(--primary-color, #325177);
          font-weight: bold;
        }
      }
      .dialog-title::before {
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-color: transparent #82B436 transparent transparent;
        border-style: solid;
        border-width: 9px 9px 0 0;
        position: absolute;
        left: -15px;
        bottom: 5px;
      }
    }

    .dialog-bottom {
      font-size: 14px;
      color: #666;
      line-height: 1.5;
      text-align: center;
      padding-bottom: 20px;
    }
  }

  .service-form {
    padding: 10px 0;

    :deep(.el-form-item) {
      margin-bottom: 10px;

      .el-form-item__label {
        padding-bottom: 2px;
        color: #333;
        font-size: 12px;

        line-height: 1.4;
      }

      .el-input__inner {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        font-size: 12px;

        &:focus {
          border-color: var(--primary-color, #325177);
        }
      }

      .el-textarea__inner {
        padding: 12px;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        font-size: 14px;
        min-height: 100px;

        &:focus {
          border-color: var(--primary-color, #325177);
        }
      }
    }

    .form-footer {
      margin-bottom: 0;
      margin-top: 30px;
      text-align: center;

      :deep(.el-form-item__content) {
        margin-left: 0 !important;
      }

      .el-button {
        width: 100%;
        height: 36px;
        background: var(--primary-color, #325177);
        border-color: var(--primary-color, #325177);
        font-size: 14px;

        border-radius: 8px;

        &:hover {
          background: var(--primary-color, #325177);
          border-color: var(--primary-color, #325177);
          opacity: 0.9;
        }
        &:active {
          background: var(--primary-color, #325177);
          border-color: var(--primary-color, #325177);
          opacity: 0.8;
        }
      }
    }
  }

  // 文件上传区域样式优化
  .upload-area {
    border: 2px dashed #E5E5E5;
    border-radius: 4px;
    padding: 16px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    margin-top: 8px;

    &:hover {
      border-color: #325177;
      background: rgba(50, 81, 119, 0.02);
    }

    .el-icon-upload {
      font-size: 24px;
      color: #999;
      margin-bottom: 8px;
    }

    .upload-text {
      p {
        margin: 0;
        color: #333;
        font-size: 13px;

        &.upload-tip {
          margin-top: 6px;
          color: #999;
          line-height: 1.4;
          font-size: 11px;
        }
      }
    }
  }

  .file-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #F7F7F7;
    border-radius: 4px;
    margin-top: 8px;

    .file-icon {
      color: #325177;
      font-size: 18px;
    }

    .file-name {
      flex: 1;
      font-size: 13px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-actions {
      color: #999;
      cursor: pointer;
      padding: 5px;

      &:hover {
        color: #F56C6C;
      }
    }
  }
}

// 全局样式覆盖
:deep(.el-dialog__headerbtn) {
  z-index: 10;
  .el-dialog__close {
    color: #999;
    font-size: 20px;
  }
}
</style> 